var _defs, _rect, _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLockMagnetLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-3{fill-rule:evenodd;}.cls-4,.cls-5{stroke-width:0.75px;}.cls-5{isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Locked_magnet_46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 46,
    height: 46
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unlock_icon",
    "data-name": "Unlock icon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.92,
    y: 17.96,
    width: 30.16,
    height: 27.14,
    rx: 5.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.23,18V2.69c0-1-1.3-1.79-2.9-1.79H18.91C17.31.9,16,1.7,16,2.69V18"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.66,36.25v1.16a1.09,1.09,0,0,1-1,1.16H22c-3.3,0-6-3.12-6-7s2.68-7,6-7h3.66a1.09,1.09,0,0,1,1,1.16v1.17a1.09,1.09,0,0,1-1,1.16H22a3.27,3.27,0,0,0-3,3.49,3.27,3.27,0,0,0,3,3.49h3.69A1.09,1.09,0,0,1,26.66,36.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.29,24.61V28.1m0,7v3.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29,26.94s1,1.39,1,4.65-1,4.66-1,4.66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.65,29.26A5.86,5.86,0,0,1,28,31.59a5.86,5.86,0,0,1-.34,2.33"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockMagnetLocked);
export default __webpack_public_path__ + "static/media/icon_lock_magnet_locked.1c18ae4b10aeeaac1985467431cd4002.svg";
export { ForwardRef as ReactComponent };